/**
 * Non-Site Observations form.
 *
 * milkweed_species is one shared field for both observation types — the
 * label text switches via .systematic/.incidental spans (toggled below)
 * rather than using two separate fields writing the same column.
 */
module.exports = function init_nonsite_observations_form($) {

  if (!window.acf) return;

  // nectar_plant: AJAX search (MLMP_LU_NectarPlantSpecies is ~23k rows)
  // instead of ACF's default local Select2, narrowed by state_us when
  // country is US.
  function init_nectar_plant_select() {

    // Checked on the wrapper, not the <select> — Select2 hides the select
    // itself once initialized. Return value lets callers below tell a
    // real init apart from a bail-out while still hidden.
    const $wrap = $('.nectar-plant-ajax-search');
    const $select = $wrap.find('select');
    if (!$select.length || !$wrap.is(':visible')) return false;

    function current_state() {
      const $form = $select.closest('.af-form');
      const country = $form.find('.acf-field[data-name="country"] select').val();
      if (country !== 'US') return '';
      return $form.find('.acf-field[data-name="state_us"] select').val() || '';
    }

    if ($select.data('select2')) {
      $select.select2('destroy');
    }

    // Select2 reads data-placeholder off the element and overwrites the
    // constructor option, so ACF's own "Select" wins unless changed here.
    $select.attr('data-placeholder', 'Start typing to search...');
    $select.removeData('placeholder');

    $select.select2({
      placeholder: 'Start typing to search...',
      width: '100%',
      minimumInputLength: 3,
      language: {
        inputTooShort: function () { return ''; },
      },
      ajax: {
        url: mlmp_settings.ajax_url,
        type: 'POST',
        dataType: 'json',
        delay: 300,
        data: function (params) {
          return {
            action: 'search_nectar_plants',
            ajax_nonce: mlmp_settings.nonce,
            search: params.term,
            state: current_state(),
          };
        },
        processResults: function (data) {
          const results = data.results || [];
          if (data.truncated) {
            results.push({ id: '', text: 'Refine your search to see more results', disabled: true });
          }
          return { results: results };
        },
      },
    });

    return true;
  }

  // Waits for ACF's own select2 init (select2-hidden-accessible class),
  // keeps watching until init_nectar_plant_select() actually succeeds.
  function watch_for_nectar_plant_select2_init() {
    const container = document.querySelector('.nectar-plant-ajax-search');
    if (!container) return;

    const select = container.querySelector('select');
    if (!select) return;

    if (select.classList.contains('select2-hidden-accessible') && init_nectar_plant_select()) {
      return;
    }

    const observer = new MutationObserver(function (mutations, obs) {
      if (select.classList.contains('select2-hidden-accessible') && init_nectar_plant_select()) {
        obs.disconnect();
      }
    });
    observer.observe(select, { attributes: true, attributeFilter: ['class'] });
  }

  watch_for_nectar_plant_select2_init();

  // show_field (Field model), not show (the accordion's own action, which
  // passes a jQuery element instead).
  acf.addAction('show_field', function (field) {
    const $el = field && field.$el;
    if (!$el || !$el.hasClass('nectar-plant-ajax-search')) return;
    init_nectar_plant_select();
  });

  acf.addAction('ready', function () {

    const $form = $('.af-form');
    if (!$form.length) return;

    const $type_field = $form.find('.acf-field[data-name="observation_type"]');
    const $species_label = $form.find('.acf-field[data-name="milkweed_species"] .acf-label label');
    if (!$type_field.length || !$species_label.length) return;

    const $systematic = $species_label.find('.systematic');
    const $incidental = $species_label.find('.incidental');

    function sync_species_label() {
      const is_incidental = $type_field.find('input[type="radio"]:checked').val() === 'Incidental';
      $systematic.toggle(!is_incidental);
      $incidental.toggle(is_incidental);
    }

    $type_field.on('change', 'input[type="radio"]', sync_species_label);
    sync_species_label();

  });
};
